
export const LoadScreen = (props) => {
    return (
        <div className="text-center" style={{ background: "#000", position: "absolute", top: "0", bottom: "0", right: "0", left: "0", zIndex: 2000, overflow: "hidden" }}>
            <div className="load-screen"></div>
        </div>
    )
}